(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  // Hide wishlist counter when value is 0
  function updateWishlistCounterVisibility() {
    const wishlistCounter = document.querySelector('.wishlist-header-link .wkh-counter');
    if (wishlistCounter) {
      const count = parseInt(wishlistCounter.textContent.trim()) || 0;
      if (count === 0) {
        wishlistCounter.style.display = 'none';
      } else {
        wishlistCounter.style.display = 'inline-flex';
      }
    }
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateWishlistCounterVisibility);
  } else {
    updateWishlistCounterVisibility();
  }

  // Watch for changes to the counter (in case wishlist app updates it)
  const observer = new MutationObserver(() => {
    updateWishlistCounterVisibility();
  });

  // Start observing when counter element is available
  const checkForCounter = setInterval(() => {
    const wishlistCounter = document.querySelector('.wishlist-header-link .wkh-counter');
    if (wishlistCounter) {
      observer.observe(wishlistCounter, {
        childList: true,
        characterData: true,
        subtree: true
      });
      updateWishlistCounterVisibility();
      clearInterval(checkForCounter);
    }
  }, 100);

  // Clean up after 10 seconds if counter not found
  setTimeout(() => clearInterval(checkForCounter), 10000);

  // Header search field clear functionality and popup
  function initHeaderSearchClear() {
    const searchInput = document.getElementById('HeaderSearchInput');
    const clearContainer = document.querySelector('.header-search-clear');
    const clearButton = document.querySelector('.header-search-clear-button');
    const clearText = document.querySelector('.header-search-clear-text');
    const searchField = document.querySelector('.header-search-field');
    const searchPopup = document.querySelector('.header-search-popup');
    const searchPopupOverlay = document.querySelector('.header-search-popup-overlay');
    const predictiveSearchContainer = searchPopup?.querySelector('[data-predictive-search]');
    const headerSection = document.querySelector('.shopify-section-header');

    if (!searchInput || !clearContainer || !clearButton || !clearText || !searchField) return;
    
    if (!searchPopup) {
      console.warn('Header search popup not found');
      return;
    }
    
    if (!predictiveSearchContainer) {
      console.warn('Predictive search container not found in popup');
      return;
    }

    let searchTimeout;
    let cachedResults = {};

    function clearSearchText() {
      // Clear button - only clears text and shows default popup (don't close popup)
      searchInput.value = '';
      updateClearVisibility();
      // Keep focus in the input so focusout handlers don't close the popup
      searchInput.focus();
      // Show default results when text is cleared, but keep popup open
      getDefaultResults();
      // Keep popup open - don't call hidePopup()
    }

    function closeSearchPopup() {
      // X button - closes popup completely
      searchInput.value = '';
      searchInput.blur();
      updateClearVisibility();
      hidePopup();
    }

    function updateClearVisibility() {
      const hasValue = searchInput.value && searchInput.value.trim() !== '';
      const isFocused = document.activeElement === searchInput;
      
      // Hide placeholder when focused
      if (isFocused) {
        searchInput.setAttribute('data-placeholder', searchInput.placeholder);
        searchInput.placeholder = '';
      } else if (searchInput.getAttribute('data-placeholder')) {
        searchInput.placeholder = searchInput.getAttribute('data-placeholder');
        searchInput.removeAttribute('data-placeholder');
      }
      
      if (isFocused) {
        // When focused, always show clear icon; show the text control only when there's a value.
        if (clearButton) clearButton.style.display = 'block';
        clearContainer.style.display = 'flex';
        searchField.classList.add('is-active');

        if (hasValue) {
          clearText.style.display = 'block';
          searchInput.classList.remove('body-medium');
          searchInput.classList.add('body-regular');
        } else {
          // Keep the icon visible when focused even if no text
          clearText.style.display = 'none';
          searchInput.classList.remove('body-regular');
          searchInput.classList.add('body-medium');
        }
      } else {
        // When not focused, show Clear button only if there's text
        if (hasValue) {
          clearText.style.display = 'block';
          if (clearButton) clearButton.style.display = 'none';
          clearContainer.style.display = 'flex';
          searchInput.classList.remove('body-medium');
          searchInput.classList.add('body-regular');
          searchField.classList.add('is-active');
        } else {
          // Hide everything when not focused and empty
          clearContainer.style.display = 'none';
          searchInput.classList.remove('body-regular');
          searchInput.classList.add('body-medium');
          searchField.classList.remove('is-active');
        }
      }
    }

    function boldSearchTermInText(element, searchTerm) {
      if (!element || !searchTerm) return;

      // Robustly replace text matches in text nodes only, preserving existing HTML structure
      const escaped = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(escaped, 'gi');

      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
      const textNodes = [];
      let node;
      while ((node = walker.nextNode())) {
        textNodes.push(node);
      }

      textNodes.forEach(textNode => {
        const str = textNode.nodeValue;
        if (!str || !regex.test(str)) return;
        regex.lastIndex = 0;
        const frag = document.createDocumentFragment();
        let lastIndex = 0;
        let match;
        while ((match = regex.exec(str)) !== null) {
          const idx = match.index;
          if (idx > lastIndex) frag.appendChild(document.createTextNode(str.slice(lastIndex, idx)));
          const mark = document.createElement('strong');
          mark.textContent = match[0];
          frag.appendChild(mark);
          lastIndex = regex.lastIndex;
        }
        if (lastIndex < str.length) frag.appendChild(document.createTextNode(str.slice(lastIndex)));
        textNode.parentNode.replaceChild(frag, textNode);
      });
    }

    function boldSearchTermsInResults(searchTerm) {
      if (!searchTerm || !predictiveSearchContainer) return;
      
      // Bold text in collections
      const collectionTitles = predictiveSearchContainer.querySelectorAll('#predictive-search-results-queries-list li[id*="collection"] .caption-regular p');
      collectionTitles.forEach(title => {
        boldSearchTermInText(title, searchTerm);
      });
      
      // Bold text in pages
      const pageTitles = predictiveSearchContainer.querySelectorAll('#predictive-search-results-pages-list-desktop .caption-regular p, #predictive-search-results-pages-list-mobile .caption-regular p');
      pageTitles.forEach(title => {
        boldSearchTermInText(title, searchTerm);
      });
      
      // Bold text in product titles (match desktop behavior)
      const productTitles = predictiveSearchContainer.querySelectorAll('#predictive-search-results-products-list .predictive-search__item-heading, #predictive-search-results-products-list-mobile .predictive-search__item-heading, .predictive-search__item-heading');
      productTitles.forEach(title => {
        boldSearchTermInText(title, searchTerm);
      });
    }

    function addCategoriesHeader() {
      const queriesList = predictiveSearchContainer.querySelector('#predictive-search-results-queries-list');
      if (!queriesList) {
        return;
      }

      // Check if there are any collection items
      const firstCollectionItem = queriesList.querySelector('li[id*="collection"]');
      if (!firstCollectionItem) {
        return;
      }

      // Check if header already exists
      const listParent = queriesList.parentElement;
      if (!listParent) {
        return;
      }

      const existingHeader = listParent.querySelector('.predictive-search__categories-header');
      if (existingHeader) {
        return;
      }

      // Create header element
      const header = document.createElement('h2');
      const categoriesStringTranslated = window.theme?.translations?.categories ?? 'Categories';
      const trendingNowStringTranslated = window.theme?.translations?.trendingNow ?? 'Trending now';

      header.className = 'predictive-search__categories-header heading-4';
      // If there's a search term, label as 'Categories'; otherwise show default 'Trending now'
      header.textContent = (searchInput && searchInput.value && searchInput.value.trim().length) ? categoriesStringTranslated : trendingNowStringTranslated;

      // Insert header before the list
      listParent.insertBefore(header, queriesList);
    }

    function setupSearchForButton() {
      const searchForButton = predictiveSearchContainer.querySelector('#predictive-search-option-search-keywords button');
      if (!searchForButton) {
        return;
      }

      // Remove existing listeners by cloning the button
      const newButton = searchForButton.cloneNode(true);
      searchForButton.parentNode.replaceChild(newButton, searchForButton);

      // Add click handler to navigate to search page
      newButton.addEventListener('click', (event) => {
        event.preventDefault();
        const searchTerm = searchInput.value.trim();
        if (!searchTerm || !theme || !theme.routes || !theme.routes.search_url) {
          return;
        }
        
        // Navigate to search page with query parameter
        window.location.href = `${theme.routes.search_url}?q=${encodeURIComponent(searchTerm)}`;
      });
    }

    function showPopup() {
      if (searchPopup) {
        searchPopup.style.setProperty('display', 'flex', 'important');
        // Trigger animation by adding active class after display is set
        requestAnimationFrame(() => {
          searchPopup.classList.add('active');
        });
      } else {
        console.warn('Cannot show popup - popup element not found');
      }
      
      // Show overlay on all screen sizes (desktop and mobile)
      if (searchPopupOverlay) {
        searchPopupOverlay.style.display = 'block';
        requestAnimationFrame(() => {
          searchPopupOverlay.classList.add('active');
        });
      }
      
      // Block scroll on all screen sizes when popup is open
      document.body.style.overflow = 'hidden';
    }

    function hidePopup() {
      if (searchPopup) {
        searchPopup.classList.remove('active');
        // Wait for animation to complete before hiding
        setTimeout(() => {
          searchPopup.style.display = 'none';
        }, 500); // Match --duration-long (500ms)
      }
      
      if (searchPopupOverlay) {
        searchPopupOverlay.classList.remove('active');
        setTimeout(() => {
          searchPopupOverlay.style.display = 'none';
        }, 500);
      }
      
      // Unblock scroll
      document.body.style.overflow = '';
    }

    function getDefaultResults() {
      const trendingCollectionHandle = searchPopup?.dataset.trendingCollectionHandle;
      const trendingCollectionId = searchPopup?.dataset.trendingCollectionId;
      
      // Create cache key based on collection ID to ensure different collections show different results
      const cacheKey = `default-results-${trendingCollectionId || trendingCollectionHandle || 'none'}`;
      if (cachedResults[cacheKey] && predictiveSearchContainer) {
        predictiveSearchContainer.innerHTML = cachedResults[cacheKey];
        modifyLabelsForDefault();
        showPopup();
        return;
      }

      // Fetch default/trending results using section rendering
      const sectionId = 'default-search-results';
      const storeRoot = window.Shopify?.routes?.root ?? '';
      let fetchUrl = `${storeRoot}?section_id=${sectionId}`;
      
      // Prefer collection ID over handle (more reliable)
      if (trendingCollectionId) {
        fetchUrl += `&collection_id=${encodeURIComponent(trendingCollectionId)}`;
      } else if (trendingCollectionHandle) {
        fetchUrl += `&collection=${encodeURIComponent(trendingCollectionHandle)}`;
      }
      
      console.log('Fetching default results from:', fetchUrl, 'Collection ID:', trendingCollectionId, 'Handle:', trendingCollectionHandle);
      
      fetch(fetchUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const section = doc.querySelector('#shopify-section-default-search-results');
          
          if (!section) {
            console.warn('Default search results section not found');
            return;
          }

          if (!predictiveSearchContainer) {
            console.warn('Predictive search container not found');
            return;
          }

          const resultsMarkup = section.innerHTML;
          
          if (resultsMarkup && resultsMarkup.trim()) {
            predictiveSearchContainer.innerHTML = resultsMarkup;
            // Cache with collection-specific key
            const cacheKey = `default-results-${trendingCollectionId || trendingCollectionHandle || 'none'}`;
            cachedResults[cacheKey] = resultsMarkup;
            modifyLabelsForDefault();
            showPopup();
          }
        })
        .catch((error) => {
          console.error('Error fetching default results:', error);
        });
    }

    function modifyLabelsForDefault() {
      // Prefer changing elements that already have the categories header class
      const categoriesHeader = predictiveSearchContainer.querySelector('.predictive-search__categories-header');
      const topProductsStringTranslated = window.theme?.translations?.topProducts ?? 'Top products';
      const trendingNowStringTranslated = window.theme?.translations?.trendingNow ?? 'Trending now';

      if (categoriesHeader) {
        categoriesHeader.textContent = trendingNowStringTranslated;
      }

      // If the default section uses the older id `predictive-search-queries`, convert it
      const legacyQueriesHeader = predictiveSearchContainer.querySelector('#predictive-search-queries');
      if (legacyQueriesHeader) {
        legacyQueriesHeader.id = 'predictive-search-trending';
        legacyQueriesHeader.classList.add('predictive-search__categories-header', 'heading-4');
        legacyQueriesHeader.textContent = trendingNowStringTranslated;
        // Update the aria-labelledby on the related list if present
        const list = predictiveSearchContainer.querySelector('#predictive-search-results-queries-list');
        if (list) list.setAttribute('aria-labelledby', 'predictive-search-trending');
      }

      // Change "Products" to "Top products"
      const productsHeading = predictiveSearchContainer.querySelector('#predictive-search-products');
      if (productsHeading) {
        productsHeading.textContent = topProductsStringTranslated;
      }
    }

    function getSearchResults(searchTerm) {
      if (!searchTerm || !searchTerm.trim()) {
        hidePopup();
        return;
      }

      const queryKey = searchTerm.replace(/\s+/g, '-').toLowerCase();
      const perPage = 8;

      // Check cache
      if (cachedResults[queryKey] && predictiveSearchContainer) {
        predictiveSearchContainer.innerHTML = cachedResults[queryKey];
        
        // Setup Search for button click handler
        setupSearchForButton();
        
        showPopup();
        return;
      }

      // Fetch results
      if (!theme || !theme.routes || !theme.routes.predictive_search_url) {
        console.warn('Predictive search URL not available');
        return;
      }

      fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[limit]')}=${perPage}&${encodeURIComponent('resources[limit_scope]')}=each&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const section = doc.querySelector('#shopify-section-predictive-search');
          
          if (!section) {
            console.warn('Predictive search section not found');
            hidePopup();
            return;
          }

          if (!predictiveSearchContainer) {
            console.warn('Predictive search container not found');
            return;
          }

          // Use the entire section innerHTML (same as predictive-search.js does)
          const resultsMarkup = section.innerHTML;
          
          if (resultsMarkup && resultsMarkup.trim()) {
            predictiveSearchContainer.innerHTML = resultsMarkup;
            cachedResults[queryKey] = resultsMarkup;
            console.log('Results loaded, showing popup');
            
            // Setup Search for button click handler
            setupSearchForButton();
            
            // Add Categories header if needed (for search results, not default)
            // Bold search terms in collections and pages
            // Remove overflow scrollbar if less than 8 products
            requestAnimationFrame(() => {
              setTimeout(() => {
                addCategoriesHeader();
                boldSearchTermsInResults(searchTerm);
              }, 0);
            });
            
            showPopup();
          } else {
            // No results found
            console.log('No results found');
            predictiveSearchContainer.innerHTML = '';
            hidePopup();
          }
        })
        .catch((error) => {
          console.error('Error fetching search results:', error);
          hidePopup();
        });
    }

    function handleSearchInput() {
      const searchTerm = searchInput.value.trim();
      updateClearVisibility();

      // Clear previous timeout
      clearTimeout(searchTimeout);

      if (!searchTerm) {
        // When text is cleared, show default results
        getDefaultResults();
        return;
      }

      console.log('Search input detected:', searchTerm);
      
      // Debounce search
      searchTimeout = setTimeout(() => {
        console.log('Fetching search results for:', searchTerm);
        getSearchResults(searchTerm);
      }, 300);
    }

    // Initial check
    updateClearVisibility();

    // Listen for input changes
    searchInput.addEventListener('input', handleSearchInput);
    // Close header popup on Escape key
    searchInput.addEventListener('keyup', (e) => {
      const code = e.code ? e.code.toUpperCase() : (e.key || '').toUpperCase();
      if (code === 'ESCAPE' || code === 'ESC') {
        hidePopup();
        searchInput.blur();
      }
    });
    
    // Listen for focus/blur to update border color and popup
    searchInput.addEventListener('focus', () => {
      updateClearVisibility();
      const searchTerm = searchInput.value.trim();
      if (searchTerm && predictiveSearchContainer && predictiveSearchContainer.innerHTML) {
        showPopup();
      } else if (!searchTerm) {
        // Show default/trending results when input is focused but empty
        getDefaultResults();
      }
    });
    
    searchInput.addEventListener('blur', (e) => {
      // Delay to allow click events on popup links
      setTimeout(() => {
        updateClearVisibility();
        // Only hide if clicking outside
        if (!searchPopup?.contains(document.activeElement) && document.activeElement !== searchInput) {
          hidePopup();
        }
      }, 200);
    });

    // X button click handler
    // - On desktop (>=750px) the X should close the popup completely.
    // - On mobile the X should clear the text / keep behavior consistent.
    clearButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (window.innerWidth >= 750) {
        closeSearchPopup();
      } else {
        clearSearchText();
      }
    });

    // Clear text click handler - only clears text and shows default popup
    clearText.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      clearSearchText();
    });

    // Overlay click handler to close popup
    if (searchPopupOverlay) {
      searchPopupOverlay.addEventListener('click', () => {
        hidePopup();
        searchInput.blur();
      });
    }
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderSearchClear);
  } else {
    initHeaderSearchClear();
  }

  // Initialize mobile search modal (same logic as desktop)
  function initMobileSearchModal() {
    const searchModal = document.querySelector('.search-modal');
    if (!searchModal) {
      console.log('Mobile search modal not found, retrying...');
      setTimeout(initMobileSearchModal, 200);
      return;
    }

    const searchInput = searchModal.querySelector('.header-search-input');
    const clearContainer = searchModal.querySelector('.header-search-clear');
    const clearText = searchModal.querySelector('.header-search-clear-text');
    const searchField = searchModal.querySelector('.header-search-field');
    const predictiveSearchContainer = searchModal.querySelector('[data-predictive-search]');
    const clearButton = searchModal.querySelector('.header-search-clear-button');

    console.log('Mobile search modal init:', {
      searchInput: !!searchInput,
      clearContainer: !!clearContainer,
      clearText: !!clearText,
      searchField: !!searchField,
      predictiveSearchContainer: !!predictiveSearchContainer
    });

    if (!searchInput || !clearContainer || !clearText || !searchField || !predictiveSearchContainer) {
      // Try again after a delay
      console.log('Mobile search modal: missing elements, retrying...');
      setTimeout(initMobileSearchModal, 200);
      return;
    }

    let searchTimeout;
    let cachedResults = {};

    function boldSearchTermInTextMobile(element, searchTerm) {
      if (!element || !searchTerm) return;

      // Reuse the same robust text-node replacement logic as desktop
      const escaped = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(escaped, 'gi');

      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
      const textNodes = [];
      let node;
      while ((node = walker.nextNode())) {
        textNodes.push(node);
      }

      textNodes.forEach(textNode => {
        const str = textNode.nodeValue;
        if (!str || !regex.test(str)) return;
        regex.lastIndex = 0;
        const frag = document.createDocumentFragment();
        let lastIndex = 0;
        let match;
        while ((match = regex.exec(str)) !== null) {
          const idx = match.index;
          if (idx > lastIndex) frag.appendChild(document.createTextNode(str.slice(lastIndex, idx)));
          const mark = document.createElement('strong');
          mark.textContent = match[0];
          frag.appendChild(mark);
          lastIndex = regex.lastIndex;
        }
        if (lastIndex < str.length) frag.appendChild(document.createTextNode(str.slice(lastIndex)));
        textNode.parentNode.replaceChild(frag, textNode);
      });
    }

    function boldSearchTermsInResultsMobile(searchTerm) {
      if (!searchTerm || !predictiveSearchContainer) return;
      
      // Bold text in collections
      const collectionTitles = predictiveSearchContainer.querySelectorAll('#predictive-search-results-queries-list li[id*="collection"] .caption-regular p');
      collectionTitles.forEach(title => {
        boldSearchTermInTextMobile(title, searchTerm);
      });
      
      // Bold text in pages
      const pageTitles = predictiveSearchContainer.querySelectorAll('#predictive-search-results-pages-list-desktop .caption-regular p, #predictive-search-results-pages-list-mobile .caption-regular p');
      pageTitles.forEach(title => {
        boldSearchTermInTextMobile(title, searchTerm);
      });

      // Bold text in product titles (match desktop behavior)
      const productTitlesMobile = predictiveSearchContainer.querySelectorAll('#predictive-search-results-products-list .predictive-search__item-heading, #predictive-search-results-products-list-mobile .predictive-search__item-heading, .predictive-search__item-heading');
      productTitlesMobile.forEach(title => {
        boldSearchTermInTextMobile(title, searchTerm);
      });
    }

    function addCategoriesHeaderToMobile() {
      const queriesList = predictiveSearchContainer.querySelector('#predictive-search-results-queries-list');
      if (!queriesList) {
        return;
      }

      // Check if there are any collection items
      const firstCollectionItem = queriesList.querySelector('li[id*="collection"]');
      if (!firstCollectionItem) {
        return;
      }

      // Check if header already exists
      const listParent = queriesList.parentElement;
      if (!listParent) {
        return;
      }

      const existingHeader = listParent.querySelector('.predictive-search__categories-header');
      if (existingHeader) {
        return;
      }

      // Create header element
      const header = document.createElement('h2');
      const categoriesStringTranslated = window.theme?.translations?.categories ?? 'Categories';
      const trendingNowStringTranslated = window.theme?.translations?.trendingNow ?? 'Trending now';

      header.className = 'predictive-search__categories-header heading-4';
      // If there's a search term, label as 'Categories'; otherwise show default 'Trending now'
      header.textContent = (searchInput && searchInput.value && searchInput.value.trim().length) ? categoriesStringTranslated : trendingNowStringTranslated;

      // Insert header before the list
      listParent.insertBefore(header, queriesList);
    }

    function setupSearchForButtonMobile() {
      const searchForButton = predictiveSearchContainer.querySelector('#predictive-search-option-search-keywords button');
      if (!searchForButton) {
        return;
      }

      // Remove existing listeners by cloning the button
      const newButton = searchForButton.cloneNode(true);
      searchForButton.parentNode.replaceChild(newButton, searchForButton);

      // Add click handler to navigate to search page
      newButton.addEventListener('click', (event) => {
        event.preventDefault();
        const searchTerm = searchInput.value.trim();
        if (!searchTerm || !theme || !theme.routes || !theme.routes.search_url) {
          return;
        }
        
        // Navigate to search page with query parameter
        window.location.href = `${theme.routes.search_url}?q=${encodeURIComponent(searchTerm)}`;
      });
    }

    function clearSearch() {
      searchInput.value = '';
      searchInput.focus();
      updateClearVisibility();
      
      // Clear results
      if (predictiveSearchContainer) {
        predictiveSearchContainer.innerHTML = '';
      }
    }

    function updateClearVisibility() {
      const hasValue = searchInput.value && searchInput.value.trim() !== '';
      const isFocused = document.activeElement === searchInput;
      
      // Hide placeholder when focused
      if (isFocused) {
        searchInput.setAttribute('data-placeholder', searchInput.placeholder);
        searchInput.placeholder = '';
      } else if (searchInput.getAttribute('data-placeholder')) {
        searchInput.placeholder = searchInput.getAttribute('data-placeholder');
        searchInput.removeAttribute('data-placeholder');
      }
      
      if (isFocused) {
        // When focused, show clear controls; show icon only if present
        if (clearButton) clearButton.style.display = 'block';
        clearContainer.style.display = 'flex';
        searchField.classList.add('is-active');
        
        // Show Clear button only if there's text
        if (hasValue) {
          clearText.style.display = 'block';
          searchInput.classList.remove('body-medium');
          searchInput.classList.add('body-regular');
        } else {
          clearText.style.display = 'none';
          searchInput.classList.remove('body-regular');
          searchInput.classList.add('body-medium');
        }
      } else {
        // When not focused, show Clear button only if there's text
        if (hasValue) {
          clearText.style.display = 'block';
          if (clearButton) clearButton.style.display = 'none';
          clearContainer.style.display = 'flex';
          searchInput.classList.remove('body-medium');
          searchInput.classList.add('body-regular');
          searchField.classList.add('is-active');
        } else {
          // Hide everything when not focused and empty
          clearContainer.style.display = 'none';
          searchInput.classList.remove('body-regular');
          searchInput.classList.add('body-medium');
          searchField.classList.remove('is-active');
        }
      }
    }
    
    function clearSearchText() {
      // Clear button - only clears text and shows default popup (don't close popup)
      searchInput.value = '';
      updateClearVisibility();
      // Show default results when text is cleared, but keep popup open
      getDefaultResultsMobile();
      // Keep popup open - don't clear results
      // Focus input to keep popup visible
      searchInput.focus();
    }
    
    function closeSearchPopup() {
      // X button - closes popup completely
      searchInput.value = '';
      searchInput.blur();
      updateClearVisibility();
      if (predictiveSearchContainer) {
        predictiveSearchContainer.innerHTML = '';
      }
    }

    function getDefaultResultsMobile() {
      // Get collection handle from header popup (same setting)
      const headerPopup = document.querySelector('.header-search-popup');
      const trendingCollectionHandle = headerPopup?.dataset.trendingCollectionHandle;
      const trendingCollectionId = headerPopup?.dataset.trendingCollectionId;
      
      // Create cache key based on collection ID to ensure different collections show different results
      const cacheKey = `default-results-${trendingCollectionId || trendingCollectionHandle || 'none'}`;
      if (cachedResults[cacheKey] && predictiveSearchContainer) {
        predictiveSearchContainer.innerHTML = cachedResults[cacheKey];
        modifyLabelsForDefaultMobile();
        return;
      }

      // Fetch default/trending results using section rendering
      const sectionId = 'default-search-results';
      let fetchUrl = `/?section_id=${sectionId}`;
      
      // Prefer collection ID over handle (more reliable)
      if (trendingCollectionId) {
        fetchUrl += `&collection_id=${encodeURIComponent(trendingCollectionId)}`;
      } else if (trendingCollectionHandle) {
        fetchUrl += `&collection=${encodeURIComponent(trendingCollectionHandle)}`;
      }
      
      console.log('Fetching default results (mobile) from:', fetchUrl);
      
      fetch(fetchUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const section = doc.querySelector('#shopify-section-default-search-results');
          
          if (!section) {
            console.warn('Default search results section not found');
            return;
          }

          if (!predictiveSearchContainer) {
            console.warn('Predictive search container not found');
            return;
          }

          const resultsMarkup = section.innerHTML;
          
          if (resultsMarkup && resultsMarkup.trim()) {
            predictiveSearchContainer.innerHTML = resultsMarkup;
            // Cache with collection-specific key
            const cacheKey = `default-results-${trendingCollectionId || trendingCollectionHandle || 'none'}`;
            cachedResults[cacheKey] = resultsMarkup;
            modifyLabelsForDefaultMobile();
          }
        })
        .catch((error) => {
          console.error('Error fetching default results:', error);
        });
    }

    function modifyLabelsForDefaultMobile() {
      // Prefer changing elements that already have the categories header class
      const categoriesHeader = predictiveSearchContainer.querySelector('.predictive-search__categories-header');
      const topProductsStringTranslated = window.theme?.translations?.topProducts ?? 'Top products';
      const trendingNowStringTranslated = window.theme?.translations?.trendingNow ?? 'Trending now';

      if (categoriesHeader) {
        categoriesHeader.textContent = trendingNowStringTranslated;
      }

      // If the default section uses the older id `predictive-search-queries`, convert it
      const legacyQueriesHeader = predictiveSearchContainer.querySelector('#predictive-search-queries');
      if (legacyQueriesHeader) {
        legacyQueriesHeader.id = 'predictive-search-trending';
        legacyQueriesHeader.classList.add('predictive-search__categories-header', 'heading-4');
        legacyQueriesHeader.textContent = trendingNowStringTranslated;
        const list = predictiveSearchContainer.querySelector('#predictive-search-results-queries-list');
        if (list) list.setAttribute('aria-labelledby', 'predictive-search-trending');
      }

      // Change "Products" to "Top products"
      const productsHeading = predictiveSearchContainer.querySelector('#predictive-search-products');
      if (productsHeading) {
        productsHeading.textContent = topProductsStringTranslated;
      }
    }

    function getSearchResults(searchTerm) {
      if (!searchTerm || !searchTerm.trim()) {
        if (predictiveSearchContainer) {
          predictiveSearchContainer.innerHTML = '';
        }
        return;
      }

      const queryKey = searchTerm.replace(/\s+/g, '-').toLowerCase();
      const perPage = 8;

      // Check cache
      if (cachedResults[queryKey] && predictiveSearchContainer) {
        predictiveSearchContainer.innerHTML = cachedResults[queryKey];
        
        // Add Categories header and setup Search for button after DOM is updated
        // Bold search terms in collections and pages
        // Remove overflow scrollbar if less than 8 products
        requestAnimationFrame(() => {
          setTimeout(() => {
            addCategoriesHeaderToMobile();
            setupSearchForButtonMobile();
            boldSearchTermsInResultsMobile(searchTerm);
          }, 0);
        });
        return;
      }

      // Fetch results
      if (!theme || !theme.routes || !theme.routes.predictive_search_url) {
        console.warn('Predictive search URL not available');
        return;
      }

      fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[limit]')}=${perPage}&${encodeURIComponent('resources[limit_scope]')}=each&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const section = doc.querySelector('#shopify-section-predictive-search');
          
          if (!section) {
            console.warn('Predictive search section not found');
            if (predictiveSearchContainer) {
              predictiveSearchContainer.innerHTML = '';
            }
            return;
          }

          if (!predictiveSearchContainer) {
            console.warn('Predictive search container not found');
            return;
          }

          // Use the entire section innerHTML (same as desktop does)
          const resultsMarkup = section.innerHTML;
          
          if (resultsMarkup && resultsMarkup.trim()) {
            console.log('Mobile search: rendering results', resultsMarkup.substring(0, 100));
            predictiveSearchContainer.innerHTML = resultsMarkup;
            cachedResults[queryKey] = resultsMarkup;
            console.log('Mobile search results loaded, container:', predictiveSearchContainer);
            
            // Add Categories header and setup Search for button after DOM is updated
            // Bold search terms in collections and pages
            // Remove overflow scrollbar if less than 8 products
            requestAnimationFrame(() => {
              setTimeout(() => {
                addCategoriesHeaderToMobile();
                setupSearchForButtonMobile();
                boldSearchTermsInResultsMobile(searchTerm);
              }, 0);
            });
          } else {
            console.log('Mobile search: no results markup');
            predictiveSearchContainer.innerHTML = '';
          }
        })
        .catch((error) => {
          console.error('Error fetching mobile search results:', error);
          if (predictiveSearchContainer) {
            predictiveSearchContainer.innerHTML = '';
          }
        });
    }

    function handleSearchInput() {
      const searchTerm = searchInput.value.trim();
      updateClearVisibility();

      // Clear previous timeout
      clearTimeout(searchTimeout);

      if (!searchTerm) {
        // When text is cleared, show default results
        getDefaultResultsMobile();
        return;
      }

      // Debounce search
      searchTimeout = setTimeout(() => {
        console.log('Mobile search: fetching results for:', searchTerm);
        getSearchResults(searchTerm);
      }, 300);
    }

    // Initial check
    updateClearVisibility();

    // Listen for input changes
    searchInput.addEventListener('input', handleSearchInput);
    
    // Listen for focus to update border color
    searchInput.addEventListener('focus', () => {
      updateClearVisibility();
      const searchTerm = searchInput.value.trim();
      if (searchTerm) {
        getSearchResults(searchTerm);
      } else {
        // Show default/trending results when input is focused but empty
        getDefaultResultsMobile();
      }
    });
    
    searchInput.addEventListener('blur', () => {
      setTimeout(() => {
        updateClearVisibility();
      }, 200);
    });

    // Clear text click handler
    clearText.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      clearSearchText();
    });
    
    // X button click handler (if exists in mobile)
    const clearButtonMobile = searchModal.querySelector('.header-search-clear-button');
    if (clearButtonMobile) {
      clearButtonMobile.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeSearchPopup();
      });
    }
  }

  // Initialize mobile search modal
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(initMobileSearchModal, 100);
    });
  } else {
    setTimeout(initMobileSearchModal, 100);
  }

  } catch(e) { console.error(e); }
})();
})();
